import { useTranslation } from 'react-i18next';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  fullScreen?: boolean;
  label?: string;
}

const sizeClasses = {
  sm: 'h-6 w-6',
  md: 'h-8 w-8',
  lg: 'h-10 w-10',
};

export default function LoadingSpinner({ size = 'lg', fullScreen = false, label }: LoadingSpinnerProps) {
  const { t } = useTranslation();
  const resolvedLabel = label ?? t('components.loadingSpinner.default');
  const spinner = (
    <>
      <div className={`${sizeClasses[size]} rounded-full border-4 border-primary border-t-transparent animate-spin`} />
      <span className="sr-only">{resolvedLabel}</span>
    </>
  );

  if (fullScreen) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50 dark:bg-[#0A0F1A]" role="status">
        {spinner}
      </div>
    );
  }

  return <div role="status" className="flex items-center justify-center">{spinner}</div>;
}
